/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
    IAgentPlugin,
    IPluginMethodMap,
  } from "@vlinder-web/plugin-agent-service-react";
  // import config from "../config/issueCredential.config.json";
  // import notification from "../config/notifications.config.json";
  import axios from "axios";
  import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
  import { UPSERT_PORTFOLIO } from "../graphql";
  import { VApplication } from "../../../application";
  import {useCollection} from "../provider";
  
  const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
  };
  
  export interface ISubmitPortfolioMethods extends IPluginMethodMap {
    getSubmitPortfolio(args: any): Promise<any>;
  }
  
  export interface SubmitPortfolioProps {
    submit:boolean;
  }
  
  export class SubmitPortfolioService implements IAgentPlugin {
    readonly methods: ISubmitPortfolioMethods;
    constructor() {
      this.methods = {
        getSubmitPortfolio: this.getSubmitPortfolio.bind(this),
      };
    }
  
    async getSubmitPortfolio(args: SubmitPortfolioProps) {
      console.log(`args in issue credential`, args);
      const {portfolioTempId} = useCollection();
      const graphqlModule = getGraphQLModule();
      const client = graphqlModule.getClient("graphql-gateway");
  
      try {
        if (client) {
          const res = await client.mutate({
            mutation: UPSERT_PORTFOLIO,
            variables: {
              input:{
                portfolioTempId:portfolioTempId,
                submit:args?.submit
              }
            },
            fetchPolicy: "no-cache",
          });
          if (res?.data?.upsertPortfolio) {
            console.log(`table data`, res);
            return res?.data?.upsertPortfolio;
          }
        }
      } catch (err: any) {
        // console.log("error in issue credential", err?.message);
        throw err;
      }
    }
  }
  